type FormProps = {
  children: React.ReactNode;
  onSubmit: () => void;
};

/**
 * The <Form /> component is basic wrapper around the HTML form element. It is used to group related input elements.
 */
export const Form = ({
  children,
  onSubmit,
}: FormProps) => {
  return (
    <form
      className="space-y-10"
      onSubmit={onSubmit}
    >
      {children}
    </form>
  );
};
